/* eslint-disable */
import { useRef, useState } from "react";
import ManageContentHeader from "./manageContentHeader";
import ManageContentFoooter from "./manageContentFooter";
import ManageContentCollection from "./manageContentCollection";

const ManageContent = () => {

    const footerRef = useRef();
    const collectionRef = useRef();
    const [selectedItemsCount, setSelectedItemsCount] = useState(0);

    return (<>
        <ManageContentHeader 
            onLoad={(item,filter)=> collectionRef.current.handleLoad(item,filter)} 
            setSearchText={(text) => collectionRef.current.setSearchText(text)} 
            setFilterTemplate={(data)=> collectionRef.current.setFilterTemplate(data)} 
            setViewMode={(view)=> collectionRef.current.setViewMode(view)} 
            onExport={(mediaCategory)=> collectionRef.current.onExport(mediaCategory)} 
            onIngest={()=> collectionRef.current.onIngest()} 
            onIngestAll={(mediaCategory)=> collectionRef.current.onIngestAll(mediaCategory)} 
            selectedItemsCount = {selectedItemsCount}
        />
        <div style={{ height: "75vh" }}>
            <ManageContentCollection 
                ref={collectionRef} 
                setMessage={(msg)=>footerRef.current?.setMessage(msg)} 
                setSelectedItemCount={(count) => {
                    setSelectedItemsCount(count);
                    footerRef.current?.setSelectedItemCount(count);
                }} />
        </div>
        <ManageContentFoooter ref={footerRef} />
    </>)
}

export default ManageContent;